import {
  FollowUpActionStatus,
  IncidentSeverity,
  IncidentStatus,
  TimeSeriesOptions
} from '@lmc/ts-common'
import { getKeys } from './getKeys'

export const incidentReportsTranslations = {
  ACTION_TITLES_REQUIRED: 'Some actions are missing title',
  INCIDENT_REPORTING: 'Incident Reporting',
  INCIDENT_REPORT: 'Incident Report',
  UPDATED_INCIDENT_REPORT_SETTINGS: 'Updated Incident Reports Settings',
  INCIDENT_REPORTING_DESCRIPTION:
    'Here you can add your locations where your {{variable}} usually stay. Later carers can select from these locations when they are recording incidents.',
  SEVERITY_LEVEL_NAMES: 'Severity level names',
  SEVERITY_LEVEL_DESCRIPTION:
    'There are 5 severity levels starting from Level 1 as minor and Level 5 as most major. Incidents that are closed without a case are automatically categorised to Level 1 severity.',
  LEVEL: 'Level',
  ENABLE_LOCATIONS: 'Enable locations',
  INCIDENT_CASE: 'Incident case',
  INCIDENT_DETAILS: 'Incident details',
  SEVERITY: 'Severity',
  OTHER_SERVICE_USERS_INVOLVED: 'Other {{variable}} involved',
  OTHER_PEOPLE_INVOLVED: 'Other people involved',
  OTHER_WITNESS: 'Other witness(es)',
  CARERES_INVOLVED: 'Carers involved',
  RESTRICTIVE_PRACTICES: 'Restrictive practices',
  PHYSICAL_INTERVENTION_APPLIED: 'Physical intervention applied',
  RESTRAINTS_APPLIED: 'Mechanical restraints applied',
  CHEMICAL_RESTRAINTS_APPLIED:
    'Chemical restraints applied (PRN)',
  ENVIRONMENTAL_RESTRAINTS_APPLIED: 'Environmental restraints applied',
  VERBAL_RESTRAINTS_APPLIED: 'Verbal restraints applied',
  NO_RESTRICTIVE_PRACTICES_DETAILS: 'No restrictive practices were used',
  INJURIES: 'Injuries',
  INJURIES_OF_RESIDENT: 'Injury of {{variable}}',
  INJURIES_OF_CARERS: 'Injury of Carers',
  INJURIES_OF_OTHER_PARTIES: 'Injury of other parties',
  NO_INJURIES_DETAILS: 'No injuries occurred',
  DAMAGES: 'Damages',
  PROPERTIES_OR_ENV: 'The property or the environment has been damaged',
  DAMAGES_INTRODUCING_RISK_APPLIED:
    'The property or the environment has been damaged and environmental risk has been introduced',
  NO_DAMAGES_DETAILS: 'No damages occurred',
  MEDICATIONS: 'Medications',
  PRN_MEDICATIONS: 'PRN medications administered',
  SU_OPINION: '{{variable}} opinion',
  ADDITIONAL_COMMENT: 'Additional comment',
  ADDITIONAL_COMMENT_REQUIRED:
    'An additional comment is required to close this incident',
  ATTACHMENTS: 'Attachments',
  FILE: 'File',
  IMAGE: 'Image',
  CLICK_TO_UPLOAD: 'Click to Upload',
  FOLLOW_UP_ACTIONS: 'Follow up actions',
  SAFEGUARDING: 'Requires safeguarding',
  REGULATOR_NOTIFICATION: 'Requires regulator notification',
  ADD_ACTIONS: 'Add actions',
  DEBRIEFING: 'Debriefing',
  NOTES: 'Notes',
  LEARNING_OUTCOMES: 'Learning and outcomes',
  ROOT_CAUSE: 'Root cause of the incident',
  ACTIONS_TAKEN: 'Actions taken to prevent this incident to occur again',
  OTHER_NOTES: 'Other notes',
  ADD_LOCATION: 'Add location',
  SAVE_CHANGES: 'Save changes',
  REVIEW: 'Review',
  CLOSE_INCIDENT: 'Close incident',
  REOPEN_INCIDENT: 'Reopen incident',
  CREATE_CASE: 'Create case',
  EDIT_CASE: 'Edit case',
  CREATING_INCIDENT_CASE: 'Creating Incident Case',
  EDITING_INCIDENT_CASE: 'Editing Incident Case',
  TYPE_HERE: 'Type here...',
  EARLY_ACCESS_TITLE: 'Early Access',
  DISCOVER_NEW_REPORT: 'Discover our new report and share your feedback',
  SHARE_FEEDBACK: 'Share your feedback',
  DOWNLOADING: 'Downloading...',
  EXPORT_CSV: 'Export CSV',
  EMAIL_SENT_TOAST_1: 'An email with the CSV will be sent to',
  EMAIL_SENT_TOAST_2: 'At peak times this may take a while.',
  ADD_ACTION: 'Add Action',

  // logs
  INCIDENT_TYPES: 'Incident Type',
  TITLE: 'Title',
  DESCRIPTION: 'Description',
  DATE_LOGGED: 'Date logged',
  TIME_LOGGED: 'Time logged',
  WITNESSED_BY: 'Witnessed by',
  LOCATION: 'Location',
  LINKED_GOALS: 'Linked goals',
  EDIT: 'Edit',
  DOWNLOAD_PDF: 'Download PDF',
  RESTORE: 'Restore incident',
  RESTORE_MODAL_TITLE: 'Are you sure you want to restore this incident?',
  RESTORE_MODAL_DESCRIPTION:
    'You can remove this incident anytime after it has been restored',
  REOPEN_MODAL_TITLE: 'Are you sure you want to reopen this incident?',
  REOPEN_MODAL_DESCRIPTION:
    'By reopening incident you will overwrite the review date and remove the additional comment left before. These information will remain available in the timeline.',
  LOG: 'Log',
  RECORDED_BY: 'Recorded by',
  CLOSED_BY: 'Closed by',
  CLOSE_COMMENT: 'Close comment',
  REOPENED_BY: 'Reopened by',
  LOGGED_BY: 'Logged by',
  GPS_LOCATION: 'GPS Location',
  WHY_CANT_I_SEE_THIS: `Why can't I see this?`,
  UNAVAILABLE: 'Unavailable',
  LOCATION_ACCURACY: 'Location accuracy: within {{accuracy}} meters',
  LATITUDE: 'Latitude:',
  LONGITUDE: 'Longitude:',
  REMOVE: 'Remove',
  REMOVED: 'REMOVED',
  REMOVE_INCIDENT: 'Remove incident',
  REMOVE_MODAL_TITLE: 'Are you sure you want to remove this incident?',
  REMOVE_MODAL_DESCRIPTION:
    'You can restore an incident from the log screen any time.',
  CLOSE_INCIDENT_MODAL_TITLE: 'Are you sure you want to close this incident?',
  CLOSE_INCIDENT_MODAL_DESCRIPTION:
    'By closing this incident you are also marking it as reviewed. You can reopen this incident at any time later on.',
  CLOSE_INCIDENT_MODAL_DESCRIPTION_WITH_CASE:
    'You can reopen this incident at any time later on.',
  FOLLOWING_ACTIONS_NOT_COMPLETED: 'The following actions are not completed:',
  ADD_A_COMMENT: 'Add a comment',
  CANCEL: 'Cancel',
  SAVE: 'Save',
  DETAILS: 'Details',
  RELATED_BODY: 'Related body map',
  YOU_CAN_SELECT:
    'You can select one of the previously created body maps or take a new one using the carer app and link it to the form later.',
  HANDOVER: 'Handover',
  FLAG_FOR_HANDOVER: 'Flag for handover',
  LOG_NOT_FOUND: 'Log not found',
  LOG_UPDATED: 'Log updated',
  LOG_REMOVED: 'Log removed',
  LOG_RESTORED: 'Log restored',
  CASE_CREATED: 'Case created',
  INCIDENT_CLOSED: 'Incident closed',
  INCIDENT_REOPENED: 'Incident reopened',
  EMPTY_CASE_TITLE: 'This case has no information entered',
  EMPTY_CASE_DESCRIPTION:
    'Press that blue edit button at the top right of the page to edit this case',
  CASE_UPDATED: 'Case updated',
  [IncidentStatus.needsReview]: 'NEEDS REVIEW',
  [IncidentStatus.open]: 'OPEN',
  [IncidentStatus.closed]: 'CLOSED',
  [`SEVERITY_LEVEL_${IncidentSeverity.level1}`]: 'Minor',
  [`SEVERITY_LEVEL_${IncidentSeverity.level2}`]: 'Moderate',
  [`SEVERITY_LEVEL_${IncidentSeverity.level3}`]: 'Significant',
  [`SEVERITY_LEVEL_${IncidentSeverity.level4}`]: 'Serious',
  [`SEVERITY_LEVEL_${IncidentSeverity.level5}`]: 'Major',
  REQUIRES_SAFEGUARDING: 'Requires safeguarding',
  REQUIRES_REGULATOR_NOTIFICATION: 'Requires regulator notification',
  [FollowUpActionStatus.notStarted]: 'Not started',
  [FollowUpActionStatus.pending]: 'In Progress',
  [FollowUpActionStatus.completed]: 'Completed',
  [FollowUpActionStatus.skipped]: 'Skipped',

  // Dashboard
  DASHBOARD_CARD_TITLE: 'Incidents',
  DASHBOARD_VIEW_ALL: 'View All',
  DASHBOARD_INCIDENTS_30: 'incidents in the last 30 days',
  DASHBOARD_NEEDS_REVIEW: 'Needs review',
  DASHBOARD_OPEN: 'Open cases',
  DASHBOARD_UNRESOLVED: 'Unresolved actions',
  INCIDENTS_DASHBOARD: 'Incidents Dashboard',
  ACTIONS: 'Actions',
  CASES: 'Cases',
  INCIDENTS_TIME: 'Incidents over time',
  TOP_INCIDENTS: 'Top 10 Incident types',
  FILLED_OUT: 'filled out',
  ROOT_CAUSE_PCT: 'Root cause',
  [TimeSeriesOptions.total]: 'Total',
  [TimeSeriesOptions.location]: 'Location',
  [TimeSeriesOptions.incidentType]: 'Incident type',
  [TimeSeriesOptions.severity]: 'Severity',
  NO_FILTERS: 'No filters applied',
  FILTERED_BY: 'Filtered by',
  AND_BY: 'AND by',
  FILTER_DATE: 'Date',
  FILTER_RESIDENTS: 'Residents',
  FILTER_OWNERS: 'Owned by',
  FILTER_SITES: 'Sites',
  FILTER_INCIDENT: 'Incident type',
  FILTER_LOCATION: 'Location',
  FILTER_STATUS: 'Status',
  FILTER_SEVERITY: 'Severity',
  FILTER_RESULT: 'Resulted in',
  TIME: 'Time',
  TOTAL_INCIDENTS: 'Total Incidents',
  INCIDENTS: 'Incidents',
  TYPE_OF_INCIDENT: 'Type of Incident',
  NO_DATA: 'Shoot... no data to show you',
  FILLING_CASE_DETAILS: 'To what extent are teams filling out case detail',
  SITE: 'Site',
  INCIDENT_TYPE_CHANGED: 'Incident type changed',
  INCIDENT_TYPE_WARNING:
    "You have edited the incident type. This change will be visible to everyone. Don't forget to update the incident title if you haven't done so already.",
  VIEW_ACTION_TABLE: 'View action table',

  // List
  INCIDENTS_LIST_VIEW: 'Incidents list',
  INCIDENT_TITLE: 'Incident title',
  STATUS: 'Status',
  SEVERITIES: 'Severity',
  RESULTED_IN: 'Resulted in',
  SITES: 'Sites',

  // Action owners
  OWNED_BY: 'Owned by',
  UNASSIGNED: 'Unassigned',
  OWNER: 'Owner',
  ENTER_TITLE: 'Enter title...',
  ACTION: 'Action',

  // Update actions
  INCIDENT_ACTIONS: 'Incident actions',
  UPDATE_STATUS: 'Update Status',
  UPDATE_AN_ACTION: 'Update an action'
}

export const incidentReportsConstants = getKeys(incidentReportsTranslations)
